import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import {isMobile} from 'react-device-detect';
import UserProfile from '../Configuration/UserProfile'


const sortData = (data) => {
    // Sorts the data array objects by the value of `sort_order` property
    return data.sort((a,b) => {
        if(a.sort_order < b.sort_order) return -1;
        if(a.sort_order > b.sort_order) return 1;
        return 0;
    })
}

const subMenu = (menuItem, key) => {
    return (
        <ul className="collapse list-unstyled submenu" id={"toggle-" + key}>
            <div>
                {(menuItem.dashboards !== null) && menuItem.dashboards.map((item,i) => { return (<li key={i}><a href={item.url}><i className="fas fa-tachometer-alt"></i><span>{item.title}</span></a></li>)})}
            </div>
            <div>
                {(menuItem.visualizations !== null) && menuItem.visualizations.map((item,i) => {return (<li key={i}><a href={item.url}><i className="fas fa-chart-area"></i><span>{item.title}</span></a></li>)})}
            </div>
            {(menuItem.subitems !== null) && menuItem.subitems.map((item,i) => {return (<li key={i}><a href={item.url} target={item.target}><i className={item.class_name}></i><span>{item.title}</span></a></li>)})}

        </ul>
    )
}

const hasSubmenu = (menuObject) => {
    return (menuObject.subitems !== null || menuObject.dashboards !== null || menuObject.visualizations !== null);
}

class Sidebar extends Component {
    constructor() {
        super()

        this.state = {
            loaded: false,
            menus: null,
            active: false,
        }
        this.toggleMenu = this.toggleMenu.bind(this);
    }
    
    toggleMenu() {
        const currentState = this.state.active;
        if (this.state.loaded === false) {
            return;
        }
 
        this.setState({ active: !currentState})
    }

    componentWillMount()  {

        var that = this;
        if(sessionStorage.getItem("mmenu") !== null)        
        {  
           console.log('mmenu from session sidebar')
           that.setState({loaded: true, menus: JSON.parse(sessionStorage.getItem("mmenu"))});           
        }
        else
        {
            this.profile = new UserProfile();        
            var varUserId = this.profile.UserId();
          
            let uri = config.getAcumenAPIURL('api/user/menu/' + varUserId);        
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("x-api-key", config.getAcumenAPIKey()); 
            myHeaders.append("table-prefix", config.getTablePrefix()); 

            var that = this;
            fetch(uri, {
                method: 'get',
                headers: myHeaders
            }).then(function(response) {
                if (response.status >= 400) {
                throw new Error("Bad response from server");
                }
                return response.json();
            })
            .then(function(data) {
                //console.log('user/menu: ' + data.menu);
                sessionStorage.setItem("mmenu",JSON.stringify(data.menu));                
                that.setState({loaded: true, menus: data.menu})
            });   
        } 

        /*
        let uri = config.getUriPath('users/menu' );
        var that = this;

        if(sessionStorage.getItem("umenu") !== null)        
        {           
           that.setState({loaded: true, menus: JSON.parse(sessionStorage.getItem("umenu"))});
        }
        else
        {
            fetch(uri, {
                method: 'get',
                headers: config.ApiHeaders()
               }).then(function(response) {
                if (response.status >= 400) {
                  that.setState({error: "Server Error, please try again shortly"})
                }
                return response.json();
              })
              .then(function(data) {
                //console.log("DATA");
                //console.log(data);
                console.log("DATA:", sortData(data));                
                //that.setState({loaded: true, menus: sortData(data)});                
                sessionStorage.setItem("umenu",JSON.stringify(sortData(data)));
                //console.log("DATA2:", JSON.parse(sessionStorage.getItem("umenu")));  
                that.setState({loaded: true, menus: JSON.parse(sessionStorage.getItem("umenu"))});                
            });
        } 
        */       
    }

    render() {
    
        if (this.state.loaded && isMobile) {
            return (
                <div className='sidebar-wrapper'>
                    <button type="button" id="sidebarCollapse" className={"hamburger hamburger--collapse " + (this.state.active ? "is-active" : "")} onClick={this.toggleMenu}>
                        <span className="hamburger-box"><span className="hamburger-inner"></span></span>
                    </button>
                    <nav id="sidebar" className={this.state.active ? "" : "active"}>
                        <ul className="list-unstyled components">
                            { this.state.menus.map((item, i) => {
                                return (
                                    <li key={i}>
                                        <a data-toggle={(hasSubmenu(item)) ? "collapse" : ''} target={item.target} aria-expanded="false" className={(hasSubmenu(item)) ? "root-menu-item dropdown-toggle" : 'root-menu-item'} href={(hasSubmenu(item)) ? ("#toggle-" + i) : item.url }>
                                            <i className={item.class_name}></i>
                                            <span>{item.title}</span>
                                        </a>
                                        {(hasSubmenu(item)) && subMenu(item, i) }
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                </div>
            )
        }

        return <div></div>;
    }
}

export default Sidebar


// WEBPACK FOOTER //
// ./src/Components/Shared/Sidebar.js